import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const GetPayerDistributionResponseDtoSchema = z.object({
  medicaid: z.object({
    currentPct: z.number(),
    count: z.number(),
  }),
  private: z.object({
    currentPct: z.number(),
    count: z.number(),
  }),
});

const _GetPayerDistributionRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  facilitiesIds: z.array(z.number()).optional(),
});

export type GetPayerDistributionRequestDto = z.infer<
  typeof _GetPayerDistributionRequestDtoSchema
>;
export type GetPayerDistributionResponseDto = z.infer<
  typeof GetPayerDistributionResponseDtoSchema
>;

export const getPayerDistribution = (
  params: GetPayerDistributionRequestDto,
  config?: AxiosRequestConfig<GetPayerDistributionRequestDto>
) => {
  return api
    .get('/facilities/payer-distribution', { ...config, params })
    .then(responseContract(GetPayerDistributionResponseDtoSchema));
};
